import { useEffect, useState } from 'react';
import { useGlobalState } from '../../Contexts/globalStateContext';
import { useSignalRContext } from '../../Contexts/signalrContext';
import BizCountUp from './BizCountUp';
import './biz-experience-points.scss';

type BizExperiencePointsProps = {
	legacy?: boolean;
};

const BizExperiencePoints = ({ legacy }: BizExperiencePointsProps) => {
	const { state, setState } = useGlobalState();
	const { user } = state;
	const { subscribe, unsubscribe } = useSignalRContext();
	const [experiencePoints, setExperiencePoints] = useState(user?.DefaultExperiencePoints || 0);

	// Initialize with user's current XP
	useEffect(() => {
		if (user?.DefaultExperiencePoints !== undefined) {
			setExperiencePoints(user.DefaultExperiencePoints);
		}
	}, [user?.DefaultExperiencePoints]);

	// Subscribe to SignalR experience point updates
	useEffect(() => {
		const handleExperienceUpdate = (content: unknown) => {
			const newValue = parseInt((content as string) || '0', 10);
			if (!isNaN(newValue)) {
				setExperiencePoints(newValue);

				// Update global state to keep it in sync
				setState((prevState) => ({
					...prevState,
					user: prevState.user
						? {
								...prevState.user,
								DefaultExperiencePoints: newValue,
						  }
						: prevState.user,
				}));
			}
		};

		subscribe('HubGeneric', 'EXPERIENCE_UPDATE_DEFAULT', null, handleExperienceUpdate);

		return () => {
			unsubscribe('HubGeneric', 'EXPERIENCE_UPDATE_DEFAULT', null);
		};
	}, [subscribe, unsubscribe, setState]);

	if (!user || user.Id <= 0) {
		return null;
	}

	return (
		<div className={`biz-experience-points ${legacy ? 'legacy' : ''}`}>
			<span className='biz-experience-points-label'>XP:</span>
			<BizCountUp value={experiencePoints} duration={1} separator=' ' legacy={legacy} />
		</div>
	);
};

export default BizExperiencePoints;
